<section class="flex-container login">
  <div class="col-50 cover cover-admin"></div>
  <div class="col-50 center content">
    <div class="center login-form">
      <a routerLink="/">
        <!-- <img src="assets/img/logo.webp" alt="Deluxy" class="logo"> -->
        <img src="assets/img/deluxy_nuovo_logo_1_140x.webp" alt="Deluxy" class="logo">
      </a>
      <br>
      <!-- <span class="riga"></span> -->
      <br><br>
      <a href="https://deluxy.it/luxurydelivery">
        <button class="btn hvr-shrink btn-sponsor">Scopri la consegna Deluxy</button>
      </a>
      <br>
      <br>
      <!-- <form id="loginForm" #loginForm="ngForm" (ngSubmit)="login()"> -->
      <form id="loginForm" #loginForm="ngForm" >
        <input type="email" [(ngModel)]="loginDTO.email" name="email" placeholder="La tua email" required>
        <input type="password" [(ngModel)]="loginDTO.password" name="password" placeholder="Password" required>
        <div class="remember">
          <label><input type="checkbox" [(ngModel)]="loginDTO.remember" name="remember">Resto connesso</label>
        </div>

        <button class="btn hvr-shrink" (click)="login()">Accedi<i class="ml-10 fas fa-arrow-right"></i></button>
      </form>
      <div class="useful-links">
        <a routerLink="/reset_password">Ho dimenticato la password</a>
        <!-- &nbsp;|&nbsp;
        <a routerLink="/resend_activation">Rispedisci link d'attivazione</a>
        <br>
        <a routerLink="/register">Registrati</a> -->
      </div>
    </div>
  </div>
</section>
